const PREFIX="scottbargain";
const BRAND="SCOTT BARGAINS";
const PAPER="#fbf5ef";
const INK="#342621";
const ACCENT="#d7b7a0";

function money(value){
  const amount=Number(value||0);
  return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(Number.isFinite(amount)?amount:0);
}

function visibleHeight(element){
  if(!element) return 0;
  const rect=element.getBoundingClientRect();
  const style=getComputedStyle(element);
  if(style.display==='none'||style.visibility==='hidden'||Number(style.opacity)===0) return 0;
  return rect.height;
}

function injectStyles(){
  if(document.getElementById(PREFIX+'-results-fallback-style')) return;
  const style=document.createElement('style');
  style.id=PREFIX+'-results-fallback-style';
  style.textContent=`
body{background:${PAPER}!important;color:${INK}!important;overflow-y:auto!important}
.content-for-layout .facets-block-wrapper,.content-for-layout .column-options-wrapper,.content-for-layout .products-count-wrapper,.content-for-layout .sorting-filter,.content-for-layout .skip-to-content-link,.content-for-layout .facets,.content-for-layout facets-drawer,.content-for-layout .facets__wrapper{display:none!important}
.${PREFIX}-js-collection-head{max-width:1500px;margin:0 auto;padding:72px 32px 28px;color:${INK}}
.${PREFIX}-js-collection-head small{display:block;margin-bottom:14px;font-size:12px;letter-spacing:.18em;text-transform:uppercase;font-weight:900;color:color-mix(in srgb,${INK} 68%,transparent)}
.${PREFIX}-js-collection-head h1{font-family:Georgia,"Times New Roman",serif;font-size:clamp(44px,7vw,108px);line-height:.9;margin:0 0 18px;color:${INK}}
.${PREFIX}-js-collection-head p{max-width:720px;font-size:18px;line-height:1.7;margin:0;color:color-mix(in srgb,${INK} 72%,transparent)}
.content-for-layout collection-component,.content-for-layout results-list{display:block!important;background:${PAPER}!important;color:${INK}!important}
.content-for-layout results-list{max-width:1500px!important;margin:0 auto!important;padding:10px 32px 90px!important;min-height:900px!important}
.content-for-layout .collection-wrapper{display:block!important}
.content-for-layout .product-grid{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:28px!important;padding:0!important;margin:0!important;min-height:600px!important}
.content-for-layout .product-grid__item{display:block!important;width:auto!important;max-width:none!important;min-width:0!important;min-height:100px!important;height:auto!important;opacity:1!important;transform:none!important;list-style:none!important}
.content-for-layout .${PREFIX}-js-card{display:block!important;background:#fff!important;border:1px solid color-mix(in srgb,${INK} 14%,transparent)!important;text-decoration:none!important;color:${INK}!important;height:100%!important}
.content-for-layout .${PREFIX}-js-card-media{display:block!important;width:100%!important;aspect-ratio:4/5!important;background:color-mix(in srgb,${ACCENT} 18%,#fff)!important;overflow:hidden!important}
.content-for-layout .${PREFIX}-js-card-media img{width:100%!important;height:100%!important;object-fit:cover!important;display:block!important}
.content-for-layout .${PREFIX}-js-card-meta{display:block!important;padding:16px 16px 20px!important}
.content-for-layout .${PREFIX}-js-card-title{display:block!important;font-weight:900!important;line-height:1.25!important;color:${INK}!important}
.content-for-layout .${PREFIX}-js-card-price{display:block!important;margin-top:10px!important;color:color-mix(in srgb,${INK} 72%,transparent)!important}
@media(max-width:1100px){.content-for-layout .product-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important}}
@media(max-width:640px){.${PREFIX}-js-collection-head,.content-for-layout results-list{padding-inline:18px!important}.content-for-layout .product-grid{grid-template-columns:1fr!important}}
`;
  document.head.appendChild(style);
}

function collectionHandle(){
  const match=location.pathname.match(/\/collections\/([^/?#]+)/);
  return match?decodeURIComponent(match[1]):'all';
}

async function hydrateEmptyGrid(){
  if(!location.pathname.includes('/collections/')) return;
  injectStyles();
  document.querySelectorAll('results-list[infinite-scroll]').forEach((node)=>node.removeAttribute('infinite-scroll'));
  const grid=document.querySelector('.product-grid');
  if(!grid) return;
  const first=grid.querySelector('.product-grid__item');
  const needsRender=!first || visibleHeight(first)<20 || grid.textContent.trim().length<30;
  if(!needsRender) return;
  const handle=collectionHandle();
  const response=await fetch('/collections/'+handle+'/products.json?limit=16',{credentials:'same-origin'});
  if(!response.ok) return;
  const data=await response.json();
  const products=Array.isArray(data.products)?data.products:[];
  if(!products.length) return;
  if(!document.querySelector('.'+PREFIX+'-js-collection-head')){
    const head=document.createElement('section');
    head.className=PREFIX+'-js-collection-head';
    const title=(document.title||BRAND).replace(/\s+[–|-].*$/,'')||'Collection';
    head.innerHTML='<small>edited product pages with visible GBP pricing</small><h1>'+title+'</h1><p>'+BRAND+' products are arranged in clear pages with direct product links.</p>';
    document.querySelector('#MainContent')?.prepend(head);
  }
  grid.innerHTML=products.map((product)=> {
    const image=product.images&&product.images[0]?product.images[0].src:'';
    const price=product.variants&&product.variants[0]?product.variants[0].price:'0';
    const safeTitle=String(product.title||'Product').replace(/[&<>"']/g,(char)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
    return '<li class="product-grid__item '+PREFIX+'-js-item"><a class="'+PREFIX+'-js-card" href="/products/'+product.handle+'"><span class="'+PREFIX+'-js-card-media">'+(image?'<img src="'+image+'" alt="'+safeTitle+'" loading="lazy">':'')+'</span><span class="'+PREFIX+'-js-card-meta"><span class="'+PREFIX+'-js-card-title">'+safeTitle+'</span><span class="'+PREFIX+'-js-card-price">'+money(price)+'</span></span></a></li>';
  }).join('');
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>{hydrateEmptyGrid(); setTimeout(hydrateEmptyGrid,700);});
}else{
  hydrateEmptyGrid(); setTimeout(hydrateEmptyGrid,700);
}